import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/Loader.css';
import { getAuth } from 'firebase/auth';
import { Helmet } from "react-helmet";


const NotFound = () => {
    const navigate = useNavigate();
    const [isAuthenticated, setIsAuthenticated] = useState(false);

    useEffect(() => {
        const auth = getAuth();
        const unsubscribe = auth.onAuthStateChanged((user) => {
            setIsAuthenticated(!!user);
        });

        return () => unsubscribe();
    }, []);

    const handleGoBack = () => {
        navigate(-1);
    };

    const handleLogin = () => {
        navigate('/login');
    };

    return (
        <>
            <Helmet>
                <title>404</title>
            </Helmet>
            <div className="loader-overlay">
                <div className="transaction-loader">
                    <div className="zebra-path" />
                </div>
                <div className="text-container">
                    <p className="not-found-text">Page Not Found</p>
                    {!isAuthenticated && (
                        <>
                            <p className="auth-warning">
                                You should login for full access.
                            </p>
                            <button className="login-btn" onClick={handleLogin}>
                                Login
                            </button>
                        </>
                    )}
                    <button className="go-back-btn" onClick={handleGoBack}>
                        Go Back
                    </button>
                </div>
            </div>
        </>
    );
};

export default NotFound;
